import { render } from "./CampaignsDetailPurchaseChannel.vue?vue&type=template&id=127f31ac&scoped=true"
import script from "./CampaignsDetailPurchaseChannel.vue?vue&type=script&lang=js"
export * from "./CampaignsDetailPurchaseChannel.vue?vue&type=script&lang=js"

import "./CampaignsDetailPurchaseChannel.vue?vue&type=style&index=0&id=127f31ac&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127f31ac"]])

export default __exports__